import { Stack, Table, TableData, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'
import SpecialPeriodApplicationRecordsChart from './SpecialPeriodApplicationRecordsChart'

interface SpecialPeriodApplicationRecordsProps {
  data: any
}

export default function SpecialPeriodApplicationRecords({ data }: SpecialPeriodApplicationRecordsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  const periods = [
    {
      label: '近7天',
      weekendCount: data?.nb_d7_week_apply_count ?? 0,
      weekendOrg: data?.nb_d7_week_apply_org_count ?? 0,
      nightCount: data?.nb_d7_night_apply_count ?? 0,
      nightOrg: data?.nb_d7_night_apply_org_count ?? 0,
    },
    {
      label: '近15天',
      weekendCount: data?.nb_d15_week_apply_count ?? 0,
      weekendOrg: data?.nb_d15_week_apply_org_count ?? 0,
      nightCount: data?.nb_d15_night_apply_count ?? 0,
      nightOrg: data?.nb_d15_night_apply_org_count ?? 0,
    },
    {
      label: '近1月',
      weekendCount: data?.nb_m1_week_apply_count ?? 0,
      weekendOrg: data?.nb_m1_week_apply_org_count ?? 0,
      nightCount: data?.nb_m1_night_apply_count ?? 0,
      nightOrg: data?.nb_m1_night_apply_org_count ?? 0,
    },
    {
      label: '近3月',
      weekendCount: data?.nb_m3_week_apply_count ?? 0,
      weekendOrg: data?.nb_m3_week_apply_org_count ?? 0,
      nightCount: data?.nb_m3_night_apply_count ?? 0,
      nightOrg: data?.nb_m3_night_apply_org_count ?? 0,
    },
    {
      label: '近6月',
      weekendCount: data?.nb_m6_week_apply_count ?? 0,
      weekendOrg: data?.nb_m6_week_apply_org_count ?? 0,
      nightCount: data?.nb_m6_night_apply_count ?? 0,
      nightOrg: data?.nb_m6_night_apply_org_count ?? 0,
    },
    {
      label: '近1年',
      weekendCount: data?.nb_m12_week_apply_count ?? 0,
      weekendOrg: data?.nb_m12_week_apply_org_count ?? 0,
      nightCount: data?.nb_m12_night_apply_count ?? 0,
      nightOrg: data?.nb_m12_night_apply_org_count ?? 0,
    },
  ]

  const tableData: TableData = {
    head: ['统计周期', '周末申请次数', '周末机构数', '夜间申请次数', '夜间机构数'],
    body: periods.map((period) => [
      period.label,
      period.weekendCount,
      period.weekendOrg,
      period.nightCount,
      period.nightOrg,
    ]),
  }

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            特殊时段申请观察
          </Text>
          <Text size="xs" className="text-gray-500">
            关注夜间、周末等非常规时段申请情况,以识别潜在异常操作。
          </Text>
        </div>
        {viewMode === 'table' ? (
          <Table
            data={tableData}
            highlightOnHover
            verticalSpacing="sm"
            styles={{
              table: { fontSize: '13px' },
              th: {
                backgroundColor: theme.surfaceMutedColor,
                color: theme.accentTextColor,
              },
            }}
          />
        ) : (
          <SpecialPeriodApplicationRecordsChart data={data} />
        )}
      </Stack>
    </div>
  )
}
